import { z } from 'zod';

/**
 * Watermark names keyed by group (color). The API contract is a free-form
 * map, so groups may be omitted or added without a frontend release.
 */
export const zodInvoiceWatermarksResponseSchema = z.record(
  z.string(),
  z.array(z.string()),
);
